"use strict";

(function () {
  function pauseOtherVideos(currentVideo) {
    document.querySelectorAll("video").forEach((video) => {
      if (video !== currentVideo && !video.paused) {
        video.pause();
      }
    });
  }

  // --- Video Play Button ---
  if (!customElements.get("video-play-btn")) {
    class VideoPlayButton extends HTMLElement {
      constructor() {
        super();
        this.video = null;
        this.videoId = this.dataset.id;
        // A flag to ensure we only attach video events once.
        this.videoEventsAttached = false;
      }

      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener("click", this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
        // If video events were ever attached, clean them up.
        if (this.video && this.videoEventsAttached) {
          this.video.removeEventListener("play", this.handlePlay);
          this.video.removeEventListener("pause", this.handlePause);
          this.video.removeEventListener("ended", this.handlePause);
        }
      }

      handleClick() {
        if (!this.video || !document.body.contains(this.video)) {
          this.video =
            document.getElementById(this.videoId) ||
            document.querySelector(`video[data-id="${this.videoId}"]`);
        }

        if (!this.video) {
          console.warn(
            `VideoPlayButton: Video with id "${this.videoId}" not found on click.`,
          );
          return;
        }

        if (!this.videoEventsAttached) {
          this._attachVideoEvents();
        }

        this.togglePlay();
      }

      _attachVideoEvents() {
        this.handlePlay = this.updateState.bind(this);
        this.handlePause = this.updateState.bind(this);

        this.video.addEventListener("play", this.handlePlay);
        this.video.addEventListener("pause", this.handlePause);
        this.video.addEventListener("ended", this.handlePause);

        this.videoEventsAttached = true;
        this.updateState(); // Update state immediately upon finding the video
      }

      togglePlay() {
        pauseOtherVideos(this.video);

        if (this.video.paused) {
          this.video.play();
        } else {
          if (this.video && this.video?.pause instanceof Function) {
            this.video?.pause();
          }
        }
      }

      updateState() {
        if (!this.video) return;
        const isPlaying = !this.video.paused;
        this.classList.toggle("is-playing", isPlaying);
        this.parentElement.classList.toggle("is-playing", isPlaying);
      }
    }
    customElements.define("video-play-btn", VideoPlayButton);
  }

  if (!customElements.get("video-mute-btn")) {
    class VideoMuteButton extends HTMLElement {
      constructor() {
        super();
        this.video = null;
        this.videoId = this.dataset.id;
        this.videoEventsAttached = false;
      }

      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener("click", this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
        if (this.video && this.videoEventsAttached) {
          this.video.removeEventListener(
            "volumechange",
            this.handleVolumeChange,
          );
        }
      }

      handleClick() {
        if (!this.video || !document.body.contains(this.video)) {
          this.video = document.getElementById(this.videoId);
        }

        if (!this.video) {
          console.warn(
            `VideoMuteButton: Video with id "${this.videoId}" not found on click.`,
          );
          return;
        }

        if (!this.videoEventsAttached) {
          this._attachVideoEvents();
        }

        this.toggleMute();
      }

      _attachVideoEvents() {
        this.handleVolumeChange = this.updateState.bind(this);
        this.video.addEventListener("volumechange", this.handleVolumeChange);
        this.videoEventsAttached = true;
        this.updateState();
      }

      toggleMute() {
        this.video.muted = !this.video.muted;
      }

      updateState() {
        if (!this.video) return;
        const isMuted = this.video.muted;
        this.classList.toggle("is-muted", isMuted);
      }
    }
    customElements.define("video-mute-btn", VideoMuteButton);
  }
})();
